import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import "./DialogPop.css";
import PrimaryButton from "../PrimaryButton";
import SecondaryButton from "../SecondaryButton";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function DialogPop(props) {
  return (
    <div>
      <Dialog
        onClose={props.onClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        className={`modalDialog ${props.customClass}`}
        maxWidth={props.maxWidth}
      >
        {props.hideHeader ? null : props.onClose ? (
          <DialogTitle id="customized-dialog-title" onClose={props.onClose}>
            {props.title}
          </DialogTitle>
        ) : (
          <DialogTitle id="customized-dialog-title">{props.title}</DialogTitle>
        )}
        {props.children}
        {!props.nobutton ? (
          <DialogActions className="dialogfoot">
            <PrimaryButton
              disabled={props.disabled}
              label="cancel"
              onClick={props.onClose}
            />
            <SecondaryButton
              disabled={props.disabled}
              label="Submit"
              onClick={props.onSubmit}
            />
          </DialogActions>
        ) : props.noclosebutton ? (
          <DialogActions className="dialogfoot">
            <PrimaryButton
              disabled={props.disabled}
              label="Submit"
              onClick={props.onSubmit}
            />
          </DialogActions>
        ) : (
          ""
        )}
      </Dialog>
    </div>
  );
}
